/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
class ManualChangesHandler {
    constructor(_run) {
        this._run = _run;
        this._changes = [];
        this._map = new Map();
        this._updateCounter = 0;
    }
    addDependency(observable, data) {
        this._map.set(observable, data);
        observable.addObserver(this);
        return {
            dispose: () => {
                this._map.delete(observable);
                observable.removeObserver(this);
            }
        };
    }
    beginUpdate(observable) {
        this._updateCounter++;
        this._changes.push(this._map.get(observable));
    }
    endUpdate(_observable) {
        this._updateCounter--;
        if (this._updateCounter === 0) {
            if (this._changes.length > 0) {
                const c = this._changes;
                this._changes = [];
                this._run(c);
            }
        }
    }
    handlePossibleChange(observable) {
        this._changes.push(this._map.get(observable));
    }
    handleChange(_observable, _change) {
        //this._changes.push(this._map.get(observable)!);
    }
}

export { ManualChangesHandler };
//# sourceMappingURL=ManualChangesHandler.js.map
